import { useContext, useEffect, useState } from "react";
import { get } from "../../utils/request";
import RightSideContent from "./RightSideContent";
import { BRAND_ROUTE } from "../../constants";
import { BrandContext } from "../../components/context/BrandContext";
import Loading from "../../components/atoms/Loading";

function BrandDashboard() {
  const { brandDetails: brandDetailsFromContext, loading: brandDetailsLoading, brandId } = useContext(BrandContext);
  const [magnetsForBrand, setmagnetsForBrand] = useState<BrandWithMagnets | null>(null);

  async function getmagnetsForBrandWithMagnets(id: string) {
    try {
      const magnetsForBrandResponse = await get(`${BRAND_ROUTE}${id}/?type=dashboard`);
      if (magnetsForBrandResponse === null) {
        alert("Failed to fetch brand details.");
      } else {
        setmagnetsForBrand(magnetsForBrandResponse);
      }
    } catch (err) {
      console.log("err", err);
    } finally {
      // TODO: Missing Loading State.
    }
  }

  useEffect(() => {
    if (!brandDetailsLoading && brandDetailsFromContext && brandId) {
      getmagnetsForBrandWithMagnets(brandId);
    }
  }, [brandDetailsFromContext, brandDetailsLoading]);

  if (brandDetailsLoading) return <Loading />;

  if (!magnetsForBrand) return null;

  return <RightSideContent brandWithMagnets={magnetsForBrand} />;
}
export default BrandDashboard;
